import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { keyCodes } from "src/app/shared/models/key-codes.model";
import { SharedService } from "src/app/shared/services/shared.service";
import { ValidationPipe } from "src/app/shared/components/ui/validation.pipe";
import { Subscription } from "rxjs";
import { UsersService } from "src/app/shared/services/users.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { Clinic } from "src/app/shared/models/clinic.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { InputWrapComponent } from "src/app/shared/components/ui/input-wrap.component";
import { AutoCompleteModule } from "primeng/autocomplete";
import { SpinnerComponent } from "src/app/shared/components/ui/spinner/spinner.component";
import { CheckboxWrapComponent } from "src/app/shared/components/ui/checkbox-wrap.component";

@Component({
  selector: "edit-clinic",
  templateUrl: "./edit-clinic.component.html",
  styleUrls: ["./edit-clinic.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    SelectModule,
    AutoCompleteModule,
    SpinnerComponent,
    CheckboxWrapComponent,
  ],
  standalone: true,
})
export class EditClinicComponent implements OnInit {
  @Input() clinic: Clinic;
  @Output() onCancel = new EventEmitter();

  keyCodes = keyCodes;
  saving: boolean;
  addressSuggestions: string[];

  constructor(
    private sharedService: SharedService,
    private validationPipe: ValidationPipe,
    private broshService: BroshService
  ) { }

  ngOnInit(): void { }

  public updateClinic() {
    this.saving = true;
    this.broshService.updateClinicDetails(this.clinic).subscribe(
      () => {
        this.saving = false;
        this.closePanel();
      },
      () => (this.saving = false)
    );
  }

  public closePanel() {
    this.onCancel.emit();
  }

  public allowSubmit(): boolean {
    if (this.clinic.deliveryEmail) {
      return this.validationPipe.transform(this.clinic.deliveryEmail, "email");
    }

    return true;
  }

  addressAutoComplete(event) {
    //this.addressSuggestions = ['Israel', 'Tel Aviv'];
  }
}
